export const environment = {
  production: false,
  preproduction: false,
  api: {
    BASE_URL: 'https://dev-api.collary.fr/api',
    // BASE_URL: 'http://localhost:8080/api',
    // BASE_URL: 'https://preprod-api.collary.fr/api',
    OPEN_STREET_URL: 'https://nominatim.openstreetmap.org/search?format=json',
    COMMUNES_URL: 'https://geo.api.gouv.fr/communes',
    REGIONS_URL: 'https://geo.api.gouv.fr/regions',
    DEPARTMENTS_URL: 'https://geo.api.gouv.fr/departements',
    SIRET_API_URL: 'https://scanfacture.fr/api/v1/identity',
    URL: 'https://dev-agency.collary.fr',
  },
  BASE_64: 'data:image/jpeg;base64,',
  AUTHORIZATION: 'Bearer eyJhY2Nlc3MtdG9rZW4iOiJVZVdkdm81ZEdDSXdCdjVLWDUweVdBIiwidG9rZW4tdHlwZSI6IkJlYXJlciIsImNsaWVudCI6ImRraHZiZUNyS1ZnOHNpS2pFRVF3blEiLCJleHBpcnkiOiIxNzIyNTYxMzQzIiwidWlkIjoiYWxhYUBnbWFpbC5jb20ifQ==',
  appName: 'Interim Agency - DEV',
  version: '1.0.0-dev'
};
